module.exports = "<template>\n    <div>\n        <vbl-dropdown>\n            <vbl-button>请选择</vbl-button>\n            <div slot=\"content\">\n                <div style=\"width: 200px;\">\n                    自定义内容自定义内容自定义内容自定义内容自定义内容\n                </div>\n            </div>\n        </vbl-dropdown>\n    </div>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                show: false\n            };\n        }\n    }\n</script>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/vblDropdown/example/vblDropdownExample.vue
// module id = 165
// module chunks = 0